import React, { useState } from 'react';
import Container from 'src/components/shared/Container';
import { useGetCampusHiringApplicationsWithCandidates } from 'src/hooks/campusHiring.hooks';
import { Spinner } from 'flowbite-react';
import { TypeOfUsers, UserExperienceLevelType } from 'types';
import { useSearchParams } from 'react-router-dom';
import { CandidatesTabsEnum } from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
import CandidateFilters from '../campus/campusCandidateListing/CandidateFilters';
import CandidateList from '../campus/campusCandidateListing/CandidateList';
import FresherCandidatesHeader from './FresherCandidatesHeader';
import { useGetHiringCandidatesForPosition } from 'src/hooks/position.hooks';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';

const FresherCandidateListing = ({
	experienceLevelBuckets = [UserExperienceLevelType.FRESHER],
}: {
	experienceLevelBuckets: UserExperienceLevelType[];
}) => {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get('search') || '';
	// const defaultTab = searchParams.get('tab') || '';
	const [tab, setTab] = useState(CandidatesTabsEnum.RECOMMENDATIONS);
	const [bulkSelectedCandidates, setBulkSelectedCandidates] = React.useState<string[]>([]);

	const { data, isLoading } = useGetHiringCandidatesForPosition({
		page,
		limit: rowsPerPage,
		filters: {
			sortBy: searchParams.get('sortBy') || 'bestMatch',
			roles: JSON.parse(searchParams.get('role') || '[]'),
			skills: JSON.parse(searchParams.get('skills') || '[]'),
			salary: JSON.parse(searchParams.get('salary') || '[]'),
			locations: JSON.parse(searchParams.get('location') || '[]'),
			education: JSON.parse(searchParams.get('education') || '[]'),
			expectedJoining: JSON.parse(searchParams.get('availability') || '[]'),
			experienceLevelBuckets: experienceLevelBuckets,
		},
	});

	const {
		data: applicationsData,
		isLoading: applicationLoading,
		isFetching: applicationFetching,
	} = useGetCampusHiringApplicationsWithCandidates({
		page,
		search: search,
		limit: rowsPerPage,
		onComplete: data => {
			if (data?.total === 0 && tab !== CandidatesTabsEnum.RECOMMENDATIONS) {
				setSearchParams({ tab: CandidatesTabsEnum.RECOMMENDATIONS });
			}
		},
	});

	const totalShortlistedCandidates = applicationsData?.total || 0;

	return (
		<Container>
			<div>
				<FresherCandidatesHeader experienceLevelBuckets={experienceLevelBuckets} />
			</div>

			<div className="mt-[10px]">
				<CandidateFilters
					selectedTab={tab}
					showEducationFilter={true}
					resetPage={() => setPage(0)}
					bulkSelectedCandidates={bulkSelectedCandidates}
					setBulkSelectedCandidates={setBulkSelectedCandidates}
					isApplicationApiLoading={applicationLoading || applicationFetching}
					candidates={data?.campusHiringCandidates || []}
				/>
			</div>
			{isLoading || applicationLoading ? (
				<div className="mt-[22px] flex items-center justify-center h-[50vh]">
					{/* <Spinner /> */}
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
				</div>
			) : (
				<div className="mt-[22px] pb-5">
					<CandidateList
						page={page}
						setPage={setPage}
						selectedTab={tab}
						count={data?.total || 0}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						typeOfUsers={TypeOfUsers.FRESHER}
						bulkSelectedCandidates={bulkSelectedCandidates}
						candidates={data?.campusHiringCandidates || []}
						setBulkSelectedCandidates={setBulkSelectedCandidates}
						totalShortlistedCandidates={totalShortlistedCandidates}
					/>
				</div>
			)}
		</Container>
	);
};

export default FresherCandidateListing;
